module.exports = __webpack_public_path__ + "static/media/boek_06.a8398e12.png";